"use client"

import { useEffect, useState } from "react"
import { ChevronUp } from "lucide-react"
import { Button } from "@/shared/components/ui/button"
import { cn } from "@/shared/lib/utils"

type ScrollToTopFabProps = {
    threshold?: number
    containerId?: string
    className?: string
}

function ScrollToTopFab({
    threshold = 350,
    containerId = "dashboard-content-wrapper-id",
    className,
}: ScrollToTopFabProps) {
    const [showScrollTop, setShowScrollTop] = useState(false)

    useEffect(() => {
        const container = document.getElementById(containerId)
        if (!container) return

        const onScroll = () => setShowScrollTop(container.scrollTop > threshold)
        onScroll()
        container.addEventListener("scroll", onScroll, { passive: true })
        return () => container.removeEventListener("scroll", onScroll)
    }, [containerId, threshold])

    if (!showScrollTop) return null

    return (
        <Button
            type="button"
            size="icon"
            onClick={() => {
                const container = document.getElementById(containerId)
                if (container) {
                    container.scrollTo({ top: 0, behavior: "smooth" })
                    return
                }
                window.scrollTo({ top: 0, behavior: "smooth" })
            }}
            className={cn(
                "fixed bottom-20 right-4 z-40 h-10 w-10 rounded-full bg-primary text-primary-foreground shadow-lg ring-1 ring-primary/30 hover:bg-primary/90 md:bottom-6 md:right-6 md:h-12 md:w-12",
                className
            )}
            aria-label="Return to top"
        >
            <ChevronUp className="h-5 w-5 md:h-6 md:w-6" />
        </Button>
    )
}

export default ScrollToTopFab
